import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import companyInfo from '../../../themes/themes';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Product/NextBatch';
import Tip from '../../../components/Onboarding/BuildingBlocks/OnboardingToolTip';

export default function ProductNextBatch() {
  const { business } = useCompanyContext();
  const { products } = useLinesContext();
  const theme = process.env.REACT_APP_THEME;

  return (
    <Stepper
      title={
        <span>
          How many <u>units</u> will you be purchasing in your next batch?
        </span>
      }
      hideContent={!(products && business)}
      headerWidth={600}
      contentWidth={900}
    >
      <PageLayout />
      <Tip
        tooltip={`${companyInfo[theme].company} uses your projected inventory to plan your cash flow and forecast your sales.`}
        marginTop={10}
      />
    </Stepper>
  );
}
